<template>
  <div class="market-list-desktop-header">
    <div class="market-list-desktop-header__title">
      <component :is="embedded ? 'h2' : 'h1'" class="market-list-desktop-header__text">
        {{ title }}
        <span class="market-list-desktop-header__text--small">
          {{ count }} Market<template v-if="count !== 1">s</template>
        </span>
      </component>
      <div class="market-list-desktop-header__filters">
        <market-filters-desktop-grid
          v-if="layout == 'grid'"
          :embedded="embedded"
        ></market-filters-desktop-grid>
      </div>
    </div>
  </div>
</template>

<script src="./market-list-desktop-header.js"></script>
<style src="./market-list-desktop-header.scss" lang="scss"></style>
